<template>
  <div>
    <div class="grid grid-cols-1 overflow-hidden h-full">
      <NuxtLink :to="`/blog/${props.articles?.slug}`" class="link link-hover font-medium link-no-underline h-full flex flex-col">
        <NuxtImg :src="imageArticle" class="min-h-[200px] w-full object-cover" alt="image" format="webp" />
        <div class="space-y-4 border border-base flex-1 flex flex-col">
          <div class="p-4 flex-1">
            <div class="text-xl font-medium line-clamp-2 mb-2">
              {{ props.articles?.title }}
            </div>
            <div class="line-clamp-4 -tracking-tighter text-slate-500 font-light">
              {{ props.articles?.short_description }}
            </div>
          </div>
          <hr />
          <div class="p-4 pt-0 mt-auto">
            <NuxtLink :to="`/blog/${props.articles?.slug}`" class="link link-hover font-light">
              {{ $t('read_more') }}
              <Icon name="i-heroicons-arrow-right" class="ml-2" />
            </NuxtLink>
          </div>
        </div>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { BlogDetail } from '@/types'

const props = defineProps<{
  articles: BlogDetail
}>()

const imageArticle = computed(() => {
  return props.articles?.image || 'https://placehold.jp/300x220.png'
})
</script>

<style scoped></style>
